// Works invoices store `paidAt`. Stripe PaymentIntents have no paid timestamp,
// so Chekkit Pay uses the creation time of the successful charge (which keeps
// status 'succeeded' even after a refund).
const determinePaidAt = (invoice) => {
	if (!invoice) return null;

	if (invoice.paidAt) return new Date(invoice.paidAt);

	const charges = [];
	if (invoice.charges && Array.isArray(invoice.charges.data)) {
		charges.push(...invoice.charges.data);
	}
	if (
		invoice.latest_charge &&
		typeof invoice.latest_charge === 'object' &&
		!Array.isArray(invoice.latest_charge)
	) {
		charges.push(invoice.latest_charge);
	}

	const paidCharge = charges.find(
		(charge) => charge?.status === 'succeeded' && charge.created
	);

	return paidCharge ? new Date(paidCharge.created * 1000) : null;
};

export default determinePaidAt;
